import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import UserService from "services/UserService";
import axios from "axios";
import { getAccountMeters, putApiMeterRequestBulk } from "services/ConfigServices";
import { energyData } from "variables/lists/meters";
import { metertext, meterspagetext } from "variables/meters";
import Button from "components/CustomButtons/Button";
import { AddCircleOutline } from "@mui/icons-material";
import moment from "moment";
import advancedSearchStyle from "assets/jss/material-dashboard-pro-react/components/advancedSearchStyle";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { makeStyles } from "@mui/styles";
import uuid from "react-uuid";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import CustomSelect from "components/Input/CustomSelect.js";
import LineFilter from "./LineFilter";
import Tooltip from "@mui/material/Tooltip";
import { NotificationManager } from "react-notifications";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { Menu, MenuItem } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import { withStyles } from "@mui/styles";
import LinearProgress from '@mui/material/LinearProgress';
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import MuiDialogActions from "@mui/material/DialogActions";
import ReSendDataDialog from "./ReSendDataDialog";
import HistoricDataDialog from "./HistoricDataDialog.js";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
  color: grey;
`;

const LoadingText = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;
const FilterDiv = styled.div`
  margin-right: auto;
  margin-top: 1px;
`;
const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);
const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const tableStyle = makeStyles(styles);

export default function useMetersTable() {
  const currentusertype = localStorage.getItem('userType');

  const tableclasses = tableStyle();
  const [openMenu, setOpenMenu] = React.useState(null);
  const [openMeterHistorical, setOpenMeterHistorical] = useState(false);
  const [openResenddata, setOpenResenddata] = useState(false);

  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [openloading, setOpenloading] = useState(null);

  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState([]);

  const [selectedMeters, setSelectedMeters] = useState([]);

  const [energychoice, setEnergychoice] = useState("choice");

  const handleViewMeterHistoricalOpen = () => {
    setOpenMeterHistorical(true);
  };
  const handleViewMeterHistoricalClose = () => {
    setOpenMeterHistorical(false);
  };

  const handleClickOpenResenddata = () => {
    setOpenResenddata(true);
  };
  const handleCloseResenddata = () => {
    setOpenResenddata(false);
  };

  const refreshTable = () => {
    setRefresh(!refresh);
  }
  const handleCloseLoading = () => {
    setOpenloading(false);
  };
  const handleClick = (event) => {
    setOpenMenu(event.currentTarget);
  };
  const handleClose = () => {
    setOpenMenu(null);
  };

  //Ok but should not be able to change group at this level
  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (energychoice === 'choice')
      return;
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          getAccountMeters(null, energychoice, chartIdGroup, 'meterstable'),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh, energychoice]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const removeFilter = (id) => {
    let indexToRemove = filters.findIndex((filter) =>
      filter.id === id
    )
    let newFilters = [...filters];
    newFilters.splice(indexToRemove, 1);
    setFilters(newFilters);
  }

  const addFilter = () => {
    let newFilters = [...filters];
    let newfilterobj = {
      id: uuid(),
    };
    newFilters.push(newfilterobj);
    setFilters(newFilters);
  }

  const handleFilterChange = () => {
    setFilters([...filters]);
  }

  const handleEnergychoiceChange = (event) => { setEnergychoice(event.target.value); };

  const FilterComponent = () => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <UploadButton type="button" onClick={addFilter}>
          <Button
            type="button" round
            color="transparent"
            justIcon size={"sm"}
            onClick={addFilter}
          >
            <AddCircleOutline> </AddCircleOutline>
          </Button>
          Ajouter un filtre
        </UploadButton>
      </div>
      {
        filters.map((filter) => {
          return (
            <LineFilter filter={filter} handleFilterChange={handleFilterChange} removeFilter={removeFilter} />
          )
        })
      }
    </>
  );

  const compare = (val, data, type, comparator) => {
    //console.log(val, data, type, comparator);
    if (type === 'text') {
      if (comparator === 'equals')
        return (val && val.toLowerCase() === data.toLowerCase());
      else if (comparator === 'beginswith')
        return (val && val.toLowerCase().startsWith(data.toLowerCase()));
      else if (comparator === 'endswith')
        return (val && val.toLowerCase().endsWith(data.toLowerCase()));
      else if (comparator === 'contains')
        return (val && val.toLowerCase().includes(data.toLowerCase()));
      else if (comparator === 'notcontains')
        return (val && !val.toLowerCase().includes(data.toLowerCase()));
    }
    else if (type === 'date') {
      if (comparator === 'equals')
        return (val && moment(val).isValid() && moment(val).isSame(moment.utc(data, 'YYYY-MM-DD')));
      else if (comparator === 'before')
        return (val && moment(val).isValid() && moment(val).isBefore(moment.utc(data, 'YYYY-MM-DD')));
      else if (comparator === 'after')
        return (val && moment(val).isValid() && moment(val).isAfter(moment.utc(data, 'YYYY-MM-DD')));
    }
    else if (type === 'select') {
      if (typeof val === 'number') {
        if (comparator === 'is')
          return (val === data);
        else if (comparator === 'isnot')
          return (val !== data);
      }
      else {
        if (comparator === 'is')
          return (val && val.toLowerCase() === data.toLowerCase());
        else if (comparator === 'isnot')
          return (val && val.toLowerCase() !== data.toLowerCase());
      }

    }
    else if (type === 'number') {
      if (comparator === 'equals')
        return (val && Number(val) === Number(data));
      else if (comparator === 'lower')
        return (val && Number(val) < Number(data));
      else if (comparator === 'lowerequals')
        return (val && Number(val) <= Number(data));
      else if (comparator === 'greater')
        return (val && Number(val) > Number(data));
      else if (comparator === 'greaterequals')
        return (val && Number(val) >= Number(data));
    }
    else if (type === 'listcount') {
      if (comparator === 'equals')
        return (val && val.length === Number(data));
      else if (comparator === 'lower')
        return (val && val.length < Number(data));
      else if (comparator === 'lowerequals')
        return (val && val.length <= Number(data));
      else if (comparator === 'greater')
        return (val && val.length > Number(data));
      else if (comparator === 'greaterequals')
        return (val && val.length >= Number(data));
    }
  }

  const doFilter = (item) => {
    //console.log(item);
    let result = true;
    if (filterText) {
      result = (item.meternumber && typeof item.meternumber == 'string' && item.meternumber.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.uuid && typeof item.uuid == 'string' && item.uuid.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.details?.clef && typeof item.details.clef == 'string' && item.details?.clef.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.details?.serialnumber && typeof item.details.serialnumber == 'string' && item.details?.serialnumber.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.details?.segment && typeof item.details.segment == 'string' && item.details?.segment.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.details?.cja && typeof item.details.cja == 'string' && item.details?.cja.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.details?.diameter && typeof item.details.diameter == 'string' && item.details?.diameter.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.accountid && groupInfoListById["" + item.accountid] && groupInfoListById["" + item.accountid].toLowerCase().includes(filterText.toLowerCase())) ||
        (item.details?.address?.description && typeof item.details.address.description == 'string' && item.details.address.description.toLowerCase().includes(filterText.toLowerCase()));
    }
    if (result) {
      filters.forEach((filter) => {

        let itemfiltercolumn = item[filter.column];
        if (!itemfiltercolumn) {
          if (item.details) {
            itemfiltercolumn = item.details[filter.column];
          }
        }
        if (filter.column && filter.comparator && filter.data) {
          if (filter.column === 'loadcurvestatus') {
            if (item.loadcurvestatus === 'actif')
              itemfiltercolumn = 'active';
            else if (item.loadcurvestatus === 'Service non actif')
              itemfiltercolumn = 'inactive';
            else if (item.loadcurvestatus)
              itemfiltercolumn = 'error'
          }
          if (filter.column === 'monthlydatastatus') {
            if (!item.details?.monthlyconsumption)
              itemfiltercolumn = 'inactive';
            else if (item.monthlyerror)
              itemfiltercolumn = 'error';
            else
              itemfiltercolumn = 'active'
          }
        }
        console.log(filter.column, itemfiltercolumn, filter.data, filter.datatype, filter.comparator);
        if (filter.column && filter.comparator && filter.data && itemfiltercolumn) {

          result = result && compare(itemfiltercolumn, filter.data, filter.datatype, filter.comparator);
        }
        else if (filter.column && filter.comparator && filter.data && !itemfiltercolumn)
          result = false;

      });
    }
    return result;
  }

  const filtereItemsFunction = () => {
    let filteredItemsNew = _.get(results, `meters`, []).filter(
      (item) =>
        doFilter(item)
    );
    return filteredItemsNew;
  }

  const calculatePercent = (row) => {
    let percent = 0;
    let percentexist = false;
    if (row.distribution) {
      row.distribution.map((site) => {
        if (site.divisionunit === 'percent' && site.divisionvalue) {
          percentexist = true;
          percent += Number(site.divisionvalue.replace(',', '.'));
        }
      });
    }
    if (!percentexist)
      return -1;
    return percent;
  }

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const calculateSqrMtr = (row) => {
    let sqrmtr = 0;
    let sqrmtrexist = false;
    if (row.distribution) {
      row.distribution.map((site) => {
        if (site.divisionunit === 'sqrmtr' && site.divisionvalue) {
          sqrmtrexist = true;
          sqrmtr += Number(site.divisionvalue.replace(',', '.'));
        }
      });
    }
    if (!sqrmtrexist)
      return -1;
    return sqrmtr;
  }

  const handleSubmitResetEnedisAMR = () => {
    let amrids = [];
    selectedMeters.forEach((meter) => {
      if (meter.amrid)
        amrids.push(meter.amrid);
    }
    );

    axios
      .put(
        putApiMeterRequestBulk('resetenedis'),
        {
          amrids
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Relance faite");
          refreshTable();
        }
        else
          setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });

  };

  //OK
  const headerComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = selectedMeters.map((row) => {
      let metertoexport = {};
      metertoexport[metertext.meternumber] = row.meternumber || "";
      metertoexport[metertext.status] = row.details?.status || "";
      metertoexport[metertext.serialnumber] = row.details?.serialnumber || "";
      metertoexport[metertext.key] = row.details?.clef || "";
      if (energychoice === 'electricity')
        metertoexport[metertext.segment] = row.details?.segment || "";
      else if (energychoice === 'gas')
        metertoexport[metertext.cja] = row.details?.cja || "";
      else if (energychoice === 'water')
        metertoexport[metertext.diameter] = row.details?.diameter || "";
      metertoexport[metertext.account] = groupInfoListById["" + row.accountid] || "";
      metertoexport[metertext.accountid] = row.accountid || "";
      metertoexport[metertext.address] = row.details?.address?.description || "";
      metertoexport[metertext.description] = row.details?.description || "";
      metertoexport[metertext.distribution] = (row.distribution && row.distribution.length) == 1 ?
        groupInfoListById["" + row.distribution[0].groupid] :
        (!row.distribution || row.distribution.length == 0) ?
          'Aucune distribution' : row.distribution.length + ' distributions';
      metertoexport[metertext.totaldistributionpercent] = calculatePercent(row) == -1 ? '' : new Intl.NumberFormat('fr-FR').format(calculatePercent(row)) + '%';
      metertoexport[metertext.totaldistributionsqmtr] = calculateSqrMtr(row) == -1 ? '' : new Intl.NumberFormat('fr-FR').format(calculateSqrMtr(row)) + 'm²';
      return metertoexport;
    });
    return (
      <>
        <FilterDiv>
          <CustomSelect
            inputTitle={meterspagetext.energychoice}
            selectValue={energychoice}
            handleSelectValueChange={handleEnergychoiceChange}
            data={energyData}
          />
        </FilterDiv>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!selectedMeters || selectedMeters.length < 1} />
        </UploadButton>
        {
          currentusertype == 1 &&
          <Tooltip title="Outils admin">
            <Button
              onClick={handleClick}
              color={"warning"}
              className={tableclasses.actionButton}
              disabled={!selectedMeters || selectedMeters.length < 1}
            >
              <AdminPanelSettingsIcon fontSize="large" />
            </Button>
          </Tooltip>
        }
        <Menu
          id="chart-menu"
          className={"chart-menu"}
          anchorEl={openMenu}
          keepMounted
          aria-haspopup={'menu'}
          open={Boolean(openMenu)}
          onClose={handleClose}
        >
          <MenuItem
            onClick={() => {
              handleClose();
              handleClickOpenResenddata();
            }}
            key={`handlegroup`}>
            Repasser les données des compteurs
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleClose();
              handleViewMeterHistoricalOpen();
            }}
            key={`handlegroup`}>
            Demander un historique
          </MenuItem>
          {
            (energychoice === 'electricity') &&
            <MenuItem
              onClick={() => {
                handleClose();
                handleSubmitResetEnedisAMR()
              }}
              key={`handlegroup`}>
              Relancer les réquêtes ENEDIS
            </MenuItem>
          }

        </Menu>
        <Dialog
          onClose={handleCloseLoading}
          aria-labelledby="edituser-dialog-title"
          fullWidth="true"
          maxWidth="sm"
          open={openloading}
        >
          <DialogContent dividers>
            <LoadingText>Traitement en cours</LoadingText>
            <div style={{ height: 20, marginTop: 10 }}><LinearProgress /></div>
          </DialogContent>
        </Dialog>
        <Dialog
          onClose={handleCloseResenddata}
          aria-labelledby="addMarket-dialog-title"
          //fullWidth={true}
          maxWidth="sm"
          open={openResenddata}
        >
          <CustomDialogTitle id="addMarket-dialog-title" onClose={handleCloseResenddata}>
            Relance des données
          </CustomDialogTitle>
          <DialogContent dividers>
            <ReSendDataDialog closeModal={handleCloseResenddata} meters={selectedMeters} energy={energychoice} setOpenloading={setOpenloading} />
          </DialogContent>
          <DialogActions />
        </Dialog>
        <Dialog
          onClose={handleViewMeterHistoricalClose}
          aria-labelledby="edituser-dialog-title"
          fullWidth="true"
          maxWidth="sm"
          open={openMeterHistorical}
        >
          <CustomDialogTitle id="customized-dialog-title" onClose={handleViewMeterHistoricalClose}>
            Demande d'historique pour {selectedMeters.length} compteurs
          </CustomDialogTitle>
          <DialogContent dividers>
            <HistoricDataDialog
              meters={selectedMeters}
              closeModal={handleViewMeterHistoricalClose}
              refetch={refreshTable}
              energy={energychoice}
            />
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </>
    );
  }, [filterText, resetPaginationToggle, selectedMeters, energychoice, openMenu, openloading, openResenddata, openMeterHistorical]);

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <>
        <FilterComponent />
      </>
    );
  }, [filters]);

  return {
    gridState: {
      noContextMenu: true,
      defaultPageSize: 10,
      data: filtereItemsFunction(),
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      //  subHeaderAlign: "left",
      actions: headerComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setSelectedMeters,
    energychoice
  };
}
